import {
  RequestFiltersFieldset,
  RequestLangFieldset,
  RequestOrderingsFieldset,
  RequestRefFieldset,
  RequestTypeFieldset,
} from "./components"
import { createRequest } from "./createRequest"
import { MissingParameterError } from "./MissingParameterError"

export const GetAllByTypeRequest = createRequest({
  type: "getAllByType",
  Fieldset() {
    return (
      <>
        <RequestTypeFieldset />
        <RequestLangFieldset />
        <RequestRefFieldset />
        <RequestFiltersFieldset />
        <RequestOrderingsFieldset />
      </>
    )
  },
  getSnippetArgs(options) {
    return [
      options.type || Symbol("type"),
      {
        lang: options.lang,
        ref: options.ref,
        filters: options.filters,
        orderings: options.orderings,
      },
    ]
  },
  run(client, options) {
    const { type, ...params } = options

    if (!type) {
      throw new MissingParameterError(["Type"])
    }

    return client.getAllByType(type, params)
  },
})
